<template>
  <div class="error-snackbar">
    <v-snackbar v-model="show">
      {{ error }}
      <template v-slot:action="{ attrs }">
        <v-btn color="red" text v-bind="attrs" @click="unsetError">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  computed: {
    ...mapState({
      error: (state) => state.error,
      showError: (state) => state.showError,
    }),
    show: {
      get: function () {
        return this.showError;
      },
      set: function () {
        this.unsetError();
      },
    },
  },
  methods: {
    ...mapActions({
      unsetError: "unsetError",
    }),
  },
};
</script>
